import React, { useEffect } from 'react';
import { PeekBox, PeekButton } from '@piiqtechnologies/ui-components';
import { Place } from '@piiqtechnologies/svg-icons';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../utils/ErrorProvider.js';
import { useLoader } from '../../../../utils/LoaderProvider.js';
import '../../../../utils/RefetchProvider.js';
import '../../../../utils/NotificationProvider.js';
import 'tslib';
import '../../../../utils/ContactProvider.js';
import '../../../../utils/PolicyProvider.js';
import '../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import '../../../../types/Space.js';
import '../../../../types/Tour.js';
import '../../../../utils/analyticsPlugin.js';
import '../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../utils/cookieUtils.js';
import '../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../services/base/baseDiscoverService.js';
import '../../../../services/base/baseV3Service.js';
import '../../../../services/base/baseInsightsService.js';
import '../../../../services/sgtService.js';
import '../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../services/base/internalApiBaseService.js';
import '../../../../services/base/casaBaseService.js';
import '../../../../services/scanRequestsService.js';
import '../../../../services/db/insightsReportsDB.js';
import '../../../../services/aiDiscoverability.js';
import 'dot-object';
import '../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useUpdateSpace } from '../../../../apis/space/useUpdateSpace.js';
import '../../../../apis/upload/useSignedURL.js';

const StartWithRoomCtrl = () => {
    const { getConfig, details, setViewerContext } = usePannellumViewer();
    const [updateSpace, updatedSpace, updateSpaceInProgress, updateSpaceError] = useUpdateSpace();
    const { nodeId } = getConfig();
    const isCurrentRoomSet = details.startNode === nodeId;
    const { setError } = useError();
    const { setLoader } = useLoader();
    const label = (isCurrentRoomSet && "Room set") || "Start With This Room";
    const updateStartWithRoom = () => {
        updateSpace({ _id: details._id, startNode: nodeId });
    };
    useEffect(() => {
        if (updatedSpace) {
            setViewerContext({ details: updatedSpace });
        }
    }, [updatedSpace]);
    useEffect(() => {
        if (updateSpaceError) {
            setError(updateSpaceError === null || updateSpaceError === void 0 ? void 0 : updateSpaceError.message);
        }
    }, [updateSpaceError]);
    useEffect(() => {
        setLoader(updateSpaceInProgress, "updateSpace");
        return () => setLoader(false, "updateSpace");
    }, [updateSpaceInProgress]);
    return (React.createElement(PeekBox, null,
        React.createElement(PeekButton, { onClick: (!isCurrentRoomSet && updateStartWithRoom) || undefined, "aria-label": label, variant: "outlined", color: "secondary", startIcon: React.createElement(Place, null), sx: {
                lineBreak: "auto",
                height: "auto",
                minHeight: 28,
            } }, label)));
};

export { StartWithRoomCtrl, StartWithRoomCtrl as default };
